
import { logError } from "../../utils/logError";
import Col from "../Col.vue";
import Row from "../Row.vue";
import Card from "../Card.vue";
import { AxiosClient, AxiosClientServerNuxt } from "../../utils/axios";
import { getProvinces } from "../../utils/staticData";
import Axios from "axios";
export default {
  components: { Row, Col, Card },
  watch: {
    selectedFilter: "$fetch",
  },
  data() {
    return {
      BASE_URL_STATIC: this.$config.BASE_URL_STATIC,
      defaultFilter: [
        { value: "", label: "Toàn quốc" },
        { value: "01", label: "Hà Nội" },
        { value: "79", label: "TP. Hồ Chí Minh" },
        { value: "48", label: "Đà Nẵng" },
        { value: "92", label: "Cần Thơ" },
      ],
      selectedFilter: "",
      prevFilter: "",
      searchSchoolResult: [{}, {}, {}, {}, {}],
      serverLoad: true,
      baseImageURL: this.$config.BASE_URL_RESOURCE,
      page: 1,
      limit: 10,
      totalItems: -1,
      provinces: getProvinces("array"),
    };
  },
  async fetch() {
    try {
      if (!this.serverLoad) {
        if (this.selectedFilter === this.prevFilter) {
          this.searchSchoolResult = [
            ...this.searchSchoolResult,
            ...[{}, {}, {}, {}, {}],
          ];
        } else {
          this.searchSchoolResult = [{}, {}, {}, {}, {}];
        }
      }
      const domain = this.$config.BASE_URL_CLIENT;

      const isOnServer = process.server;
      let res;
      // res = await this.$store.dispatch('ListSchool/getListSearchSchool',{
      //   page:this.page,
      //   limit:this.limit,
      //   filter:this.selectedFilter
      // });
      if (isOnServer) {
        res = await AxiosClientServerNuxt.get(
          `/api/school/get-list-school?page=${this.page}&limit=${this.limit}&filter=${this.selectedFilter}`,
          {},
        );
      } else {
        res = await Axios.get(
          `${domain}/api/school/get-list-school?page=${this.page}&limit=${this.limit}&filter=${this.selectedFilter}`,
          {},
        );
      }
      if (res.data.listSchool) {
        const { listSchool, totalItems } = res.data;
        if (this.selectedFilter === this.prevFilter && !this.serverLoad) {
          let dataWithoutLoading = this.searchSchoolResult;
          if (!this.serverLoad) {
            dataWithoutLoading = this.searchSchoolResult.slice(
              0,
              // 5 loading card
              this.searchSchoolResult.length - 5,
            );
          }
          this.searchSchoolResult = [...dataWithoutLoading, ...listSchool];
        } else {
          this.searchSchoolResult = listSchool;
        }
        this.$store.commit(
          "ListSchool/LIST_SCHOOL_HOME_PAGE_FILTER",
          this.searchSchoolResult,
        );
        this.totalItems = totalItems;
      } else {
        this.searchSchoolResult = [];
        this.totalItems = 0;
        this.$store.commit("ListSchool/LIST_SCHOOL_HOME_PAGE_FILTER", []);
      }
    } catch (e) {
      logError(e, "Fetch Search School on client");
      this.searchSchoolResult = [];
      this.totalItems = 0;
      this.$store.commit("ListSchool/LIST_SCHOOL_HOME_PAGE_FILTER", []);
    }
    this.serverLoad = false;
    // this.searchSchoolResult = [];
  },
  fetchKey: "comp-searchSchool",
  methods: {
    handleFilterChange(value) {
      this.prevFilter = this.selectedFilter;
      this.selectedFilter = value;
      this.page = 1;
    },
    getMoreSchool() {
      this.prevFilter = this.selectedFilter;
      this.page = this.page + 1;
      this.$fetch();
    },
    generateImageURL(params) {
      if (Array.isArray(params)) {
        return this.baseImageURL + params[0];
      } else {
        return this.baseImageURL + params;
      }
    },
  },
};
